import React, { Component } from 'react';

class Outputs extends Component {
	render() {
            return (
		<div class="flex-column">
		    <h3>Publications</h3>
		    <ul>
			<li>B. S. Ashby, G. R. Barrenechea, A. Lukyanov, T. Pryer, <b>A. Trenam</b>, "A finite element method for a non-Newtonian dilute polymer fluid", 2025. <i>Under review, arXiv:</i> <a href="https://arxiv.org/abs/2511.20208" target="blank">2511.20208</a>.</li>
			<li>G. R. Barrenechea, T. Pryer, <b>A. Trenam</b>, "A nodally bound-preserving discontinuous Galerkin method for the drift-diffusion equation", <i>Journal of Computational and  Applied Mathematics</i>, vol. 470, p. 116670, 2025. DOI: <a href="https://doi.org/10.1016/j.cam.2025.116670" target="blank">10.1016/j.cam.2025.116670</a>.</li>

			<li>A. Pim, T. Pryer, <b>A. Trenam</b>, "Optimal control of a kinetic equation", 2024. <i>Under review, arXiv:</i> <a href="https://arxiv.org/abs/2412.10747" target="blank">2412.10747</a>.</li>
			    <li><b>A. Trenam</b>, C. Aza, C. Jones, G. Lawrence, L. Harper, A. Rhead, E. G. Loukaides, R. Butler, "An Analytical Model for Wrinkle-free Forming of Composite Laminates", <i>Composites Part A: Applied Science and Manufacturing</i>, vol. 186, p. 108386, 2024. DOI: <a href="https://doi.org/10.1016/j.compositesa.2024.108386" target="blank">10.1016/j.compositesa.2024.108386</a>.</li>
		    </ul>
		</div>
	    );
  	}
}

export default Outputs;
